import React, { useState, useEffect, useContext } from 'react';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import { withCookies } from 'react-cookie';

import TabPanelPunchCCQ from '@components/punchCCQ/TabPanelPunchCCQ'
import styles from '@styles/punch.module.css';
import { isAuthenticated } from '@actions/authentication';
import { RenewToken } from '@utils/token';
import { ChatContext } from '@/ChatProvider';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export function PunchCCQ(props) {
    const { setIsAuthenticated } = useContext(ChatContext);
    const [authenticated, setAuthenticated] = useState(false);

    const handleTitle = () => {
        props.onLoadTitle(i18next.t('menu:punchCCQ'));
    }

    const handleToken = async () => {
        await RenewToken(props);

        isAuthenticated().then((result) => {
            setAuthenticated(result);
            setIsAuthenticated(result);
        });
    }

    useEffect(() => {
        handleTitle();
        handleToken();
    }, []);

    return (
        authenticated && <div className={styles.rootPunch}>
            <TabPanelPunchCCQ />
        </div>
    );
}

export default withNamespaces(['menu'], { wait: true })(withCookies(PunchCCQ));